import React from 'react'

import { Page, View, Text } from '@react-pdf/renderer'
import styles from '../style'
import TopBanner from '../Components/TopBanner'

import ServiceTable, {
  IServices
} from '../Components/ServiceTable/ServiceTable'

export interface IPlansPage {
  plan: {
    quoteId: string
    planId: string
    name: string
    isPartDCreditable: boolean
    innDeductible: string
    famDeductible: string
    OOPMInd: string
    OOPMFam: string
    OON: {
      innDeductible: string
      OOPMInd: string
      famDeductible: string
      OOPMFam: string
      coinsurance: string
      deductibleEmbedded: boolean
    }
    rates: {
      employeeOnly: string
      employeePlusSpouse: string
      employeePlusChildren: string
      employeePlusFamily: string
    }
    services: IServices
  }
}

const ValueRow = ({
  title,
  value,
  isFirstItem,
  isLastItem
}: {
  title: string
  value: string
  isFirstItem?: boolean
  isLastItem?: boolean
}) => (
  <View
    style={[
      styles.row,
      {
        paddingTop: isFirstItem ? 0 : 5,
        paddingBottom: isLastItem ? 0 : 5,
        borderBottom: isLastItem ? '' : '1 solid #E7EAF3'
      }
    ]}
  >
    <Text style={[styles.rowItem, styles.halfSectionValue]}>{title}</Text>
    <Text style={[styles.rowItem, styles.descriptionText]}>{value}</Text>
  </View>
)

const PlansPage = ({ plan }: IPlansPage) => {
  return (
    <Page>
      <TopBanner title="Plans" />
      <View style={styles.pageBody}>
        <Text>{plan.name}</Text>
        <View style={styles.row}>
          <Text style={[styles.descriptionText, styles.rowItem]}>
            Plan ID: {plan.planId}
          </Text>
          <Text style={[styles.descriptionText, styles.rowItem]}>
            Quote ID: {plan.quoteId}
          </Text>
        </View>
        <View style={[styles.section, styles.row]}>
          <View style={styles.rowItem}>
            <Text style={styles.quoteDetailValue}>{plan.innDeductible}</Text>
            <Text style={styles.descriptionText}>Deductible Individual</Text>
          </View>
          <View style={styles.rowItem}>
            <Text style={styles.quoteDetailValue}>{plan.famDeductible}</Text>
            <Text style={styles.descriptionText}>Deductible Family</Text>
          </View>
          <View style={styles.rowItem}>
            <Text style={styles.quoteDetailValue}>{plan.OOPMInd}</Text>
            <Text style={styles.descriptionText}>OOPM Individual</Text>
          </View>
          <View style={styles.rowItem}>
            <Text style={styles.quoteDetailValue}>{plan.OOPMFam}</Text>
            <Text style={styles.descriptionText}>OOPM Family</Text>
          </View>
        </View>
        <View
          style={[
            styles.row,
            { gap: 10, alignItems: 'flex-start', marginBottom: 16 }
          ]}
        >
          <View
            style={[
              styles.section,
              {
                flex: 1,
                height: '100%',
                padding: 0,
                justifyContent: 'center',
                backgroundColor: '#F8F9FA'
              }
            ]}
          >
            <ValueRow
              title="Deductible Individual OON"
              value={plan.OON.innDeductible}
              isFirstItem
            />
            <ValueRow title="OOPM Individual OON" value={plan.OON.OOPMInd} />
            <ValueRow
              title="Deductible Family OON"
              value={plan.OON.famDeductible}
            />
            <ValueRow title="OOPM Family OON" value={plan.OON.OOPMFam} />
            <ValueRow title="Coinsurance OON" value={plan.OON.coinsurance} />
            <ValueRow
              title="Deductible Embedded"
              value={plan.OON.deductibleEmbedded ? 'Yes' : 'No'}
              isLastItem
            />
          </View>
          <View
            style={[
              styles.section,
              {
                flex: 1,
                height: '90%',
                justifyContent: 'center',
                padding: 0,
                paddingVertical: 5
              }
            ]}
          >
            <Text style={[styles.sectionHeader, { paddingLeft: 5 }]}>
              Rates
            </Text>
            <ValueRow
              title="Employee Only"
              value={plan.rates.employeeOnly}
              isFirstItem
            />
            <ValueRow
              title="Employee + Spouse"
              value={plan.rates.employeePlusSpouse}
            />
            <ValueRow
              title="Employee + Child(ren)"
              value={plan.rates.employeePlusChildren}
            />
            <ValueRow
              title="Employee + Family"
              value={plan.rates.employeePlusFamily}
              isLastItem
            />
          </View>
        </View>
        <ServiceTable services={plan.services} />
      </View>
    </Page>
  )
}

export default PlansPage
